export const prices = [350, 500, 800];
